import { render, staticRenderFns } from "./RequestListSortButton.vue?vue&type=template&id=63ac84da&scoped=true&"
import script from "./RequestListSortButton.vue?vue&type=script&lang=js&"
export * from "./RequestListSortButton.vue?vue&type=script&lang=js&"
import style0 from "./RequestListSortButton.vue?vue&type=style&index=0&id=63ac84da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac84da",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CRadio: require('@chakra-ui/vue').CRadio, CRadioGroup: require('@chakra-ui/vue').CRadioGroup, CBox: require('@chakra-ui/vue').CBox})
